<script setup lang="ts">
import {Component} from "../types.ts";

defineProps<{
  item: Component
}>();

</script>

<template>
  <div :id="item.props.id" :style="item.props.style">
    <div :class="`frame-${item.props.id}`"
         :style="{position: 'relative', width: item.props.style?.width, height: item.props.style?.height}">
      <iframe :src="item.published.src" :height="`${item.props.style?.height}`" :width="`${item.props.style?.width}`"
              :style="`${item.props.style}`"/>
    </div>
    <slot>
    </slot>
  </div>

</template>

<style scoped>

</style>